import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { UserType } from "sprout-graphql";
import { Box, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { getItemUrl } from "sprout-lib";
const BreadcrumbsPseudoWrapper = styled(Box)`
  font-size: ${themeGet("fontSizes.0")}px;

  ${media.target("pointer")} {
    a:hover {
      text-decoration: underline;
    }
  }
`;
const BreadcrumbsPseudo = (props)=>{
    const { owner , rootTopic , parentTopic , className , showTeam , renderAsLink  } = props;
    const { firstName , username  } = owner;
    const showRootTopic = rootTopic.id !== parentTopic.id;
    const showBetween = parentTopic.parentTopicId !== rootTopic.id;
    return /*#__PURE__*/ _jsxs(BreadcrumbsPseudoWrapper, {
        className: className,
        children: [
            showTeam && owner.type === UserType.Team && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    renderAsLink ? /*#__PURE__*/ _jsx(NavLink, {
                        to: `/${owner.username}`,
                        children: firstName || username
                    }) : /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        children: firstName || username
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        px: "4px",
                        children: "/"
                    })
                ]
            }),
            showRootTopic && (renderAsLink ? /*#__PURE__*/ _jsx(NavLink, {
                to: getItemUrl(rootTopic, owner),
                children: rootTopic.title
            }) : /*#__PURE__*/ _jsx(Text, {
                as: "span",
                children: rootTopic.title
            })),
            showRootTopic && !showBetween && /*#__PURE__*/ _jsx(Text, {
                as: "span",
                px: "4px",
                children: "/"
            }),
            showRootTopic && showBetween && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        px: "4px",
                        children: "/"
                    }),
                    "..",
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        px: "4px",
                        children: "/"
                    })
                ]
            }),
            renderAsLink ? /*#__PURE__*/ _jsx(NavLink, {
                to: getItemUrl(parentTopic, owner),
                children: parentTopic.title
            }) : /*#__PURE__*/ _jsx(Text, {
                as: "span",
                children: parentTopic.title
            })
        ]
    });
};
export default BreadcrumbsPseudo;
